<template>
  <div>
    <div v-if="!libraryUploader">
      <file-uploader-file
        v-for="fileRecord in fileRecords"
        :key="fileRecord.id"
        :file-record="fileRecord"
        @remove="removeFileRecord(fileRecord)"
      />
    </div>
    <div v-else>
      <v-simple-table class="striped">
        <thead>
          <tr>
            <th>
              File
            </th>
            <th>
              Size
            </th>
            <th>
              Artist
            </th>
            <th>
              Title
            </th>
            <th>
              Progress
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr v-if="fileRecords.length === 0">
            <td colspan="6">
              <div class="text-center pa-5">
                There are no files for upload yet.
              </div>
            </td>
          </tr>
          <library-uploader-file
            v-for="fileRecord in fileRecords"
            :key="fileRecord.id"
            :file-record="fileRecord"
            @remove="removeFileRecord(fileRecord)"
          />
        </tbody>
      </v-simple-table>
    </div>

    <div
      class="py-8 mt-3 text-center rounded-lg"
      style="border: 3px dashed rgba(28, 23, 31, 0.5); position: relative;"
    >
      <input
        v-if="readonly !== true"
        ref="fileInput"
        title=""
        :disabled="disabled === true || (hasMultiple && !canAddMore)"
        type="file"
        :multiple="hasMultiple"
        class="file-input"
        :accept="accept || '*'"
        :capture="capture || undefined"
        @change="filesChanged"
      >
      Click here to upload or drag and drop
    </div>
  </div>
</template>
<script>
import { mixin as fileAgent } from 'vue-file-agent'
import FileUploaderFile from '@/components/helpers/fileUploader/FileUploaderFile'
import LibraryUploaderFile from '@/components/library/LibraryUploaderFile'

export default {
  name: 'FileUploader',
  components: { LibraryUploaderFile, FileUploaderFile },
  mixins: [fileAgent],
  props: {
    customDragHandler: {
      type: [String, Boolean],
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: [String, Boolean],
      default: false
    },
    auto: {
      type: Boolean,
      default: false
    },
    uploadWithCredentials: {
      type: Boolean,
      default: true
    },
    additionalFormData: {
      type: Object,
      default: () => ({})
    },
    libraryUploader: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isDragging(value) {
      if (value) this.$emit('drag:show')
      else this.$emit('drag:hide')
    },
    overallProgress(value) {
      this.$emit('progress', value)
    }
  },
  beforeDestroy() {
    this.destroyEventListeners()
  },
  mounted() {
    this.setUpEventListeners()
  },
  methods: {
    async setUpEventListeners() {
      await this.$nextTick()

      const element = document.querySelector(this.customDragHandler)

      if (!element) return

      element.addEventListener('dragover', ev => this.onDragOver(ev))
      element.addEventListener('dragenter', ev => this.onDragEnter(ev))
      element.addEventListener('dragleave', ev => this.onDragLeave(ev))
      element.addEventListener('drop', ev => this.onDrop(ev))
    },
    destroyEventListeners() {
      const element = document.querySelector(this.customDragHandler)

      if (!element) return

      element.removeEventListener('dragover', ev => this.onDragOver(ev))
      element.removeEventListener('dragenter', ev => this.onDragEnter(ev))
      element.removeEventListener('dragleave', ev => this.onDragLeave(ev))
      element.removeEventListener('drop', ev => this.onDrop(ev))
    },
    onDragOver(e) {
      this.dragOver(e)
    },
    onDragEnter(e) {
      this.dragEnter(e)
    },
    onDragLeave(e) {
      this.dragLeave(e)
    },
    onDrop(e) {
      this.drop(e)
    },
    performUpload() {
      return this.upload(this.uploadUrl, this.uploadHeaders, this.fileRecords, fileRecord => {
        const formData = new FormData()

        for (const key of Object.keys(this.additionalFormData)) {
          if (Array.isArray(this.additionalFormData[key])) {
            for (const value of this.additionalFormData[key]) {
              formData.append(key + '[]', value)
            }
          } else {
            formData.append(key, this.additionalFormData[key])
          }
        }

        formData.append('file', fileRecord.file)

        return formData
      })
    },
    removeFileRecord(fileRecordOrRaw) {
      const rawFileRecord = this.getFileRecordRawInstance(fileRecordOrRaw)

      this.$emit('beforedelete', rawFileRecord)
      if (!this.uploadUrl) {
        return
      }
      this.deleteFileRecord(fileRecordOrRaw)
    }
  }
}
</script>

<style scoped>
.file-input {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 10;
  cursor: pointer;
}
</style>
